// Single place that reloads the page, so tests can replace it (jsdom does not
// allow stubbing window.location.reload).
export function reloadPage(): void {
  window.location.reload();
}
